import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAKMJVBxcxHycDCDZKz44iwm4-ddV-vYEQ",
  authDomain: "jdoc-jtech.firebaseapp.com",
  projectId: "jdoc-jtech",
  storageBucket: "jdoc-jtech.firebasestorage.app",
  messagingSenderId: "51164286150",
  appId: "1:51164286150:web:02373b30966172e59cdbc7",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
